module.exports = __webpack_public_path__ + "static/step_2-a8a6123157ea92b98f344255b813c88e.png";